/** @param {object} state - Root Redux state */
// eslint-disable-next-line import/prefer-default-export
export const getSessionTiming = (state) => state.sessionTiming;
